"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatisticalSignificanceQualitativeRating = void 0;
var StatisticalSignificanceQualitativeRating;
(function (StatisticalSignificanceQualitativeRating) {
    StatisticalSignificanceQualitativeRating["indistinctFromNoise"] = "indistinctFromNoise";
    StatisticalSignificanceQualitativeRating["suggestive"] = "suggestive";
    StatisticalSignificanceQualitativeRating["significant"] = "significant";
    StatisticalSignificanceQualitativeRating["verySignificant"] = "verySignificant";
})(StatisticalSignificanceQualitativeRating || (exports.StatisticalSignificanceQualitativeRating = StatisticalSignificanceQualitativeRating = {}));
//# sourceMappingURL=statistical-significance-rating.js.map